import type { DialogType } from '../../../@types';
import type { AffiliateCampaign } from '../../../@types/api';
import { useModal } from '../../../contexts/ModalContext';
import CreateCampaignForm from './campaign/CreateCampaignForm';
import EditCampaignForm from './campaign/EditCampaignForm';

const CampaignForm = (props: DialogType) => {
  const { item } = useModal<AffiliateCampaign>();

  if (item) return <EditCampaignForm {...props} campaign={item} />;

  return <CreateCampaignForm {...props} />;
};

export default CampaignForm;
